import React, { useState, useEffect } from 'react';
import { Box, IconButton } from '@mui/material';
import { KeyboardArrowLeft, KeyboardArrowRight } from '@mui/icons-material';

export default function MediaCarousel({ mediaFiles=[]}) {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isHovering, setIsHovering] = useState(false);
  const [touchStart, setTouchStart] = useState(0);

  const goToNextImage = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === mediaFiles.length - 1 ? 0 : prevIndex + 1
    );
  };

  const goToPrevImage = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? mediaFiles.length - 1 : prevIndex - 1
    );
  };

  const handleDotClick = (index) => {
    setCurrentIndex(index);
  };

  const handleTouchStart = (e) => {
    setTouchStart(e.touches[0].clientX);
  };

  const handleTouchMove = (e) => {
    if (!touchStart) return;
    const touchEnd = e.touches[0].clientX;

    if (touchStart - touchEnd > 5) {
      goToNextImage();
    } else if (touchStart - touchEnd < -5) {
      goToPrevImage();
    }
    setTouchStart(0);
  };

  return (
    <Box
      sx={styles.carouselContainer}
      onMouseEnter={() => setIsHovering(true)}
      onMouseLeave={() => setIsHovering(false)}
      onTouchStart={handleTouchStart}
      onTouchMove={handleTouchMove}
    >
      <div style={{posiyon:"absolute",width:"100%",height:"100%"}}>
      {mediaFiles.map((item, index) => (
        <React.Fragment key={index}>
         {index === currentIndex &&
            <>
          {item?.fileType && item?.fileType.startsWith('image') ? (
            <img src={item?.url} alt="Preview" style={{ width: '100%', height: '100%', objectFit: 'contain' }} />
          ) : (
            <video src={item?.url} style={{ width: '100%', height: '100%', objectFit: 'contain' }} controls />
          )}
          </>}
          </React.Fragment>
      ))}
      
      </div>
      {(isHovering && currentIndex > 0) &&(
          <IconButton sx={styles.leftArrow} onClick={goToPrevImage}>
            <KeyboardArrowLeft />
          </IconButton>
        )}
        {(isHovering) && (
          <IconButton sx={styles.rightArrow} onClick={goToNextImage}>
            <KeyboardArrowRight />
          </IconButton>
        )}
      <Box sx={styles.dotsContainer}>
        {mediaFiles.map((_, index) => (
          <Box
            key={index}
            onClick={() => handleDotClick(index)}
            sx={{
              ...styles.dot,
              backgroundColor: currentIndex === index ? '#f8f8f8' : '#ddd',
            }}
          />
        ))}
      </Box>
    </Box>
  );
}

const styles = {
  carouselContainer: {
    position: 'relative',
    width: '100%',
    height: '100%',
    overflow: 'hidden',
  },
  imageContainer: {
    width: '100%',
    height: '100%',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    objectFit: 'contain',
    position: 'relative',
    transition: 'background-image 0.5s ease-in-out',
  },
  leftArrow: {
    position: 'absolute',
    top: '50%',
    left: '10px',
    transform: 'translateY(-50%)',
    color: '#fff',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.7)',
    },
  },
  rightArrow: {
    position: 'absolute',
    top: '50%',
    right: '10px',
    transform: 'translateY(-50%)',
    color: '#fff',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.7)',
    },
  },
  dotsContainer: {
    display: 'flex',
    justifyContent: 'center',
    position: 'absolute',
    bottom: '10px',
    width: '100%',
  },
  dot: {
    width: '8px',
    height: '8px',
    borderRadius: '50%',
    margin: '0 3px',
    cursor: 'pointer',
    transition: 'background-color 0.3s',
  },
};

